jQuery(document).ready(function($) {
    // Team Grid Filter mit Isotope
    const $teamGrid = $('.component-team-grid-repeater > .component-inner');
    const $filterButtons = $('.component-team-filter .filter-btn');

    
    // Prüfe ob Isotope, das Team-Grid und Filter-Buttons existieren
    if ($teamGrid.length && $filterButtons.length && typeof $.fn.isotope !== 'undefined') {
        
        // Warte auf das Laden aller Bilder, bevor Isotope initialisiert wird
        $teamGrid.imagesLoaded(function() {
        
            
            // Umschalten auf Block-Layout
            $teamGrid.addClass('isotope-initialized');
            
            // Isotope-Klassen zu Items hinzufügen
            $teamGrid.find('.component-team-member').addClass('isotope-item');
            
            // Initialisiere Isotope mit korrektem Layout
            $teamGrid.isotope({
                itemSelector: '.component-team-member',
                layoutMode: 'fitRows',
                transitionDuration: '0'
            });
            
            // Layout nach der Initialisierung erzwingen
            setTimeout(function() {
                $teamGrid.isotope('layout');
            }, 100);
            
            // Zusätzliche Layout-Optimierung für bessere Performance
            $teamGrid.on('layoutComplete', function(event, laidOutItems) {
                // Verhindere weitere Layout-Berechnungen während der Animation
                $(this).off('layoutComplete');
            });
        });
        
        // Filter-Funktionalität
        $filterButtons.on('click', function(e) {
            e.preventDefault();
            
            const $this = $(this);
            const filterValue = $this.attr('data-filter');
            
            // Aktiven Button aktualisieren
            $filterButtons.removeClass('active');
            $this.addClass('active');
            
            // Isotope Filter anwenden
            $teamGrid.isotope({
                filter: filterValue
            });
            
            // Optional: Hier könnte ein Scroll zum Grid hinzugefügt werden
            // if (filterValue !== '*') {
            //     $('html, body').animate({
            //         scrollTop: $teamGrid.offset().top - 100
            //     }, 600);
            // }
        });
        
        // URL-Parameter für direkte Links zu gefilterten Ansichten
        const urlParams = new URLSearchParams(window.location.search);
        const filterParam = urlParams.get('team_filter');
        
        if (filterParam) {
            const $targetButton = $filterButtons.filter(`[data-filter="${filterParam}"]`);
            if ($targetButton.length) {
                $targetButton.trigger('click');
            }
        }
        
        // Layout Complete Event wird jetzt in der imagesLoaded-Callback definiert
        
        // Responsive Anpassungen mit sanftem Re-Layout
        let resizeTimer;
        $(window).on('resize', function() {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function() {
                // Sanftes Re-Layout ohne Isotope zu zerstören
                $teamGrid.isotope('layout');
            }, 500); // Längere Verzögerung für stabileres Layout
        });
        
    } 
});